<template>
  <div style="background-color: #fff;padding:20px;">
    <!-- 表格数据 -->
    <el-table v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="form.personInfoList" :cell-style="initOperatorColumnStyle">
      <el-table-column align="center" prop="name" label="自由职业者名称" :min-width="140" />
      <el-table-column align="center" prop="idNo" label="身份证号" :min-width="180" show-overflow-tooltip />
      <el-table-column align="center" prop="phone" label="实名手机号" :min-width="120" />
      <el-table-column align="center" prop="authStatus" label="实名状态" :min-width="120" show-overflow-tooltip>
        <template #default="scope">
          {{ isRealNameLabel[scope.row.authStatus] }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="result" label="校验结果" :min-width="120">
        <template #default="scope">
          <custom-tag :label="resultLabel[scope.row.result]" :type="resultStyle[scope.row.result]" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="errorMsg" label="失败原因" :min-width="180" show-overflow-tooltip />
    </el-table>
  </div>
</template>

<script setup lang="ts">
import { initOperatorColumnStyle, CustomTag } from '@vue3/components';
import { ref, watch } from 'vue';
import { resultLabel, resultStyle, IFreelancerImportItem, isRealNameLabel } from '@core/main/types';

const loading = ref(false);

const props = defineProps({
  uploadData: {
    type: Array<IFreelancerImportItem>,
    default() {
      return [];
    },
  },
});
const form = ref<any>({ personInfoList: [] });

watch(
  () => props.uploadData,
  () => {
    form.value.personInfoList = props.uploadData;
  },
  { immediate: true },
);

function validate() {
  return true;
}

defineExpose({
  /**
   * 信息校验
   * return {boolean} true 通过， false失败
  */
  validate,
  /** 获取表单数据 */
  getValues: () => form.value,
  /** 表单数据重置（base props.data） */
});

</script>
